/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidActivate200,
  PostApiV1IndividualpaymentParcelsParcelidActivate400,
  PostApiV1IndividualpaymentParcelsParcelidActivate401,
  PostApiV1IndividualpaymentParcelsParcelidActivate500,
  PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidActivatePathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidActivate.ts";

export const postApiV1IndividualpaymentParcelsParcelidActivatePathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidActivatePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidActivate200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidActivate200>;

/**
 * @description Parcela não está cancelada
 */
export const postApiV1IndividualpaymentParcelsParcelidActivate400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidActivate400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidActivate401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidActivate401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidActivate500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidActivate500>;

export const postApiV1IndividualpaymentParcelsParcelidActivateMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidActivate200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse>;
